
import React from 'react';
import { Home, Search, Package, MessageCircle, User } from 'lucide-react';
import { User as UserType } from '../types';

interface MobileBottomNavProps {
  currentPage: string;
  onNavigate: (page: string) => void;
  onOpenSearch: () => void;
  onToggleChat: () => void;
  onOpenAuth: () => void;
  currentUser: UserType | null;
  isChatOpen?: boolean;
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ 
  currentPage, 
  onNavigate, 
  onOpenSearch, 
  onToggleChat, 
  onOpenAuth,
  currentUser,
  isChatOpen = false
}) => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-[100]">
      {/* Container principal: Borda cinza ultra-fina e sombra mais suave */}
      <div className="bg-white border-t border-gray-100 shadow-[0_-5px_20px_rgba(0,0,0,0.04)] h-16 flex items-center justify-around relative px-2 rounded-t-[24px]">
        
        {/* INÍCIO */}
        <button 
          onClick={() => onNavigate('home')}
          className="flex flex-col items-center gap-0.5 flex-1 transition-all active:scale-95"
        >
          <div className={`p-1 rounded-xl transition-colors ${currentPage === 'home' ? 'text-primary' : 'text-gray-300'}`}>
            <Home size={20} strokeWidth={2} />
          </div>
          <span className={`text-[8px] font-bold uppercase tracking-wider ${currentPage === 'home' ? 'text-primary' : 'text-gray-400'}`}>Início</span>
        </button>

        {/* PRODUTOS */}
        <button 
          onClick={() => onNavigate('produtos')}
          className="flex flex-col items-center gap-0.5 flex-1 transition-all active:scale-95"
        >
          <div className={`p-1 rounded-xl transition-colors ${currentPage === 'produtos' ? 'text-primary' : 'text-gray-300'}`}>
            <Package size={20} strokeWidth={2} />
          </div>
          <span className={`text-[8px] font-bold uppercase tracking-wider ${currentPage === 'produtos' ? 'text-primary' : 'text-gray-400'}`}>Produtos</span>
        </button>

        {/* BOTÃO CENTRAL (BUSCAR) - Reduzido e Refinado */}
        <div className="relative -top-5 flex flex-col items-center">
            <button 
                onClick={onOpenSearch}
                className="w-14 h-14 bg-primary text-white rounded-[20px] shadow-lg shadow-primary/30 flex items-center justify-center transform transition-transform active:scale-90 border-[4px] border-white"
            >
                <Search size={22} strokeWidth={2.5} />
            </button>
            <span className="mt-1 text-[8px] font-bold uppercase tracking-wider text-primary">Buscar</span>
        </div>

        {/* CHAT */}
        <button 
          onClick={onToggleChat}
          className="flex flex-col items-center gap-0.5 flex-1 transition-all active:scale-95"
        >
          <div className={`p-1 rounded-xl transition-colors ${isChatOpen ? 'text-primary' : 'text-gray-300'}`}>
            <MessageCircle size={20} strokeWidth={2} />
          </div>
          <span className={`text-[8px] font-bold uppercase tracking-wider ${isChatOpen ? 'text-primary' : 'text-gray-400'}`}>Chat</span>
        </button>

        {/* CONTA */}
        <button 
          onClick={() => {
            if (currentUser) {
              onNavigate('admin');
            } else {
              onOpenAuth();
            }
          }}
          className="flex flex-col items-center gap-0.5 flex-1 transition-all active:scale-95"
        >
          <div className={`p-1 rounded-xl transition-colors ${currentPage === 'admin' ? 'text-primary' : 'text-gray-300'}`}>
            <User size={20} strokeWidth={2} />
          </div>
          <span className={`text-[8px] font-bold uppercase tracking-wider ${currentPage === 'admin' ? 'text-primary' : 'text-gray-400'}`}>
            {currentUser ? 'Perfil' : 'Conta'}
          </span>
        </button>

      </div>
      {/* Área de segurança */}
      <div className="h-[env(safe-area-inset-bottom)] bg-white w-full"></div>
    </div>
  );
};

export default MobileBottomNav;
